export default __webpack_public_path__ + "static/media/pdf-icon.02244905.svg";